import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { showLoader, hideLoader } from '../../../../store/common/slice';
import { useAccessToken } from '../../../../common/hooks/useAccessToken';
import Button from '../../../../common/Button';
import BllinkRobot from '../../../../images/newDesign/bllink_robot.svg';
import { ReconciliationModalStyled } from '../BankAdjustmentsNew.styled';

const ManualApproveModal = ({ show, onModalHide, bllinkId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();

    const onApproveClick = async () => {
        bllinkId.forEach(async (id) => {
            dispatch(showLoader());
            const response = await client.post(`/managers/markAsApproved/${id}`);
            dispatch(hideLoader());
            if (response.success) NotificationManager.success(t('expenses.bank_adjustments.approved_transaction', {id: id}));              
            else NotificationManager.error(t('expenses.bank_adjustments.not_approved_transaction', {id: id}))
        });

        onModalHide();
        setTimeout(() => window.location.reload(), 2000);      
    };

    return (
        <>
            {/* preloading image before modal */}
            <img src={BllinkRobot} alt="" style={{position: 'absolute', width: 0, height: 0}}/>
            <ReconciliationModalStyled
                show={show}
                onHide={onModalHide}
                centered
            >
                <span
                    className='modal-close'
                    onClick={onModalHide}
                >
                    &#215;
                </span>

                <Modal.Body>
                    <img src={BllinkRobot} alt="" />
                    <div className='modal-text-header'>{t('expenses.bank_adjustments.press_approve')}</div>
                    <Button
                        onClick={onApproveClick}
                    >
                        {t('expenses.approve')}
                    </Button>
                </Modal.Body>
            </ReconciliationModalStyled>      
        </>
    );
};

export default ManualApproveModal;